const HEADER = 64;
export function scrollToId(id) {
  if (typeof window === "undefined") return;
  const el = document.getElementById(id);
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!el) {
    window.scrollTo({
      top: 0,
      behavior: reduced ? "auto" : "smooth"
    });
    return;
  }
  const top = el.getBoundingClientRect().top + window.scrollY - HEADER - 8;
  window.scrollTo({
    top,
    behavior: reduced ? "auto" : "smooth"
  });
}